'use client'
import { __awaiter } from '../../../../../../_virtual/_tslib.js';
import { useMemo, useCallback } from 'react';
import { DynamicError } from '@dynamic-labs/utils';
import '../../../../events/dynamicEvents.js';
import '../../../../context/DynamicContext/DynamicContext.js';
import '@dynamic-labs/sdk-api-core';
import '../../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import '../../../../context/ViewContext/ViewContext.js';
import '@dynamic-labs/wallet-book';
import '../../../constants/colors.js';
import '../../../constants/values.js';
import '../../../../store/state/loadingAndLifecycle.js';
import '../../../../shared/consts/index.js';
import { useInternalDynamicContext } from '../../../../context/DynamicContext/useDynamicContext/useInternalDynamicContext.js';
import '../../../../context/CaptchaContext/CaptchaContext.js';
import '../../../../context/ErrorContext/ErrorContext.js';
import { USER_NOT_LOGGED_IN } from '../../../constants/errors.js';
import '@dynamic-labs/multi-wallet';
import 'react-international-phone';
import { verifyEmail } from '../../../../data/api/email/email.js';
import { storeAuthTokenAndUser } from '../../../../store/state/user/storeAuthTokenAndUser/storeAuthTokenAndUser.js';
import '../../../../store/state/user/user.js';
import '../../../../config/ApiEndpoint.js';
import { verifySms } from '../../../../data/api/sms/sms.js';
import '../../../../store/state/projectSettings/projectSettings.js';
import '../../../../context/AccessDeniedContext/AccessDeniedContext.js';
import '../../../../context/AccountExistsContext/AccountExistsContext.js';
import '../../../../context/UserWalletsContext/UserWalletsContext.js';
import { useVerification } from '../../../../context/VerificationContext/VerificationContext.js';
import 'react-dom';
import '../../../../context/ThemeContext/ThemeContext.js';
import { useHandleVerificationRequired, getVerificationDestination } from '../../useHandleVerificationRequired/useHandleVerificationRequired.js';
import '@dynamic-labs/types';
import '../../../../context/LoadingContext/LoadingContext.js';
import '../../../../context/WalletContext/WalletContext.js';
import '../../useEmbeddedWallet/useSecureEnclaveEmbeddedWallet/constants.js';
import 'yup';
import '../../../../context/MockContext/MockContext.js';
import '../../../../views/CollectUserDataView/useFields.js';
import '../../../../context/FieldsStateContext/FieldsStateContext.js';
import '../../useUserUpdateRequest/useUpdateUser/userFieldsSchema.js';
import '../../../../context/UserFieldEditorContext/UserFieldEditorContext.js';
import '@dynamic-labs/rpc-providers';
import '../../../../store/state/environmentId.js';
import '../../../../store/state/walletConnectorOptions.js';
import 'react-i18next';
import '../../../../components/Accordion/components/AccordionItem/AccordionItem.js';
import '../../../../components/Alert/Alert.js';
import '../../../../components/ShadowDOM/ShadowDOM.js';
import '../../../../components/IconButton/IconButton.js';
import '../../../../components/InlineWidget/InlineWidget.js';
import '../../../../components/Input/Input.js';
import '../../../../components/IsBrowser/IsBrowser.js';
import '../../../../components/MenuList/Dropdown/Dropdown.js';
import '../../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../../components/OverlayCard/OverlayCardTarget/OverlayCardTarget.js';
import '../../../../components/PasskeyCreatedSuccessBanner/PasskeyCreatedSuccessBanner.js';
import '../../../../components/Popper/Popper/Popper.js';
import '../../../../components/Popper/PopperContext/PopperContext.js';
import 'react-focus-lock';
import 'qrcode';
import 'formik';
import '../../../../context/FooterAnimationContext/index.js';
import '../../../../context/WalletGroupContext/WalletGroupContext.js';
import '../../../../context/IpConfigurationContext/IpConfigurationContext.js';
import '../../../../context/SocialRedirectContext/SocialRedirectContext.js';
import '../../../../widgets/DynamicBridgeWidget/views/WalletsView/components/SecondaryWallets/SecondaryWallets.js';
import '../../../../locale/locale.js';
import '@hcaptcha/react-hcaptcha';
import '../../../../widgets/DynamicWidget/context/DynamicWidgetContext.js';
import '../../../../context/PasskeyContext/PasskeyContext.js';
import '../../../../store/state/sendBalances.js';
import '../../../../widgets/DynamicWidget/components/DynamicWidgetHeader/DynamicWidgetHeader.js';
import '../../../../views/TransactionConfirmationView/TransactionConfirmationView.js';
import '../../../../widgets/DynamicWidget/views/ManagePasskeysWidgetView/PasskeyCard/PasskeyCard.js';
import '../../../../../index.js';
import '../../../../store/state/tokenBalances.js';
import '../../../../shared/utils/functions/getInitialUrl/getInitialUrl.js';

/**
 * Same as useOtpVerificationRequest, but requires you to pass it a handleVerificationRequired method as param.
 * This is to avoid a circular logic issue, as handleVerificationRequired needs to use the logic in this file as well.
 */
const useOtpVerificationRequestRaw = () => {
    const { environmentId, user, userWithMissingInfo } = useInternalDynamicContext();
    const { verificationUUID: contextVerificationUUID } = useVerification();
    const verifyOtp = useCallback((handleVerificationRequired, verificationToken, destination, localVerificationUUID) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!user && !userWithMissingInfo)
            throw new DynamicError(USER_NOT_LOGGED_IN);
        // VerificationUUID is saved in the context in case the view changes
        // after a profile update (changing the view from edit profile to verify email)
        if (!localVerificationUUID && !contextVerificationUUID)
            throw new DynamicError('No verification UUID is available');
        const verificationUUID = (localVerificationUUID !== null && localVerificationUUID !== void 0 ? localVerificationUUID : contextVerificationUUID);
        const verify = destination === 'email' ? verifyEmail : verifySms;
        const updateSelfResponse = yield verify({
            environmentId,
            verificationToken,
            verificationUUID,
        });
        const updatedUser = updateSelfResponse.user;
        const missingFields = (_a = updatedUser === null || updatedUser === void 0 ? void 0 : updatedUser.missingFields) !== null && _a !== void 0 ? _a : [];
        const requiredVerificationDestination = getVerificationDestination(updateSelfResponse.nextView);
        // If verification is not needed then we can update the user profile immediately.
        storeAuthTokenAndUser(updateSelfResponse);
        if (requiredVerificationDestination)
            return handleVerificationRequired({
                destination: requiredVerificationDestination,
                missingFields,
                updateUserProfileResponse: updateSelfResponse,
            });
        return {
            isEmailVerificationRequired: false,
            isSmsVerificationRequired: false,
            missingFields,
            updateUserProfileResponse: updateSelfResponse,
        };
    }), [contextVerificationUUID, environmentId, user, userWithMissingInfo]);
    return { verifyOtp };
};
/**
 * Hook to make verifications and already handle nuances like handling additional verifications
 * and setting the user jwt on success
 */
// ATTENTION: THIS IS EXPOSED TO THE PUBLIC!
const useOtpVerificationRequest = () => {
    const handleVerificationRequired = useHandleVerificationRequired();
    const { verifyOtp } = useOtpVerificationRequestRaw();
    return useMemo(() => ({
        verifyOtp: (token, destination, verificationUUID) => verifyOtp(handleVerificationRequired, token, destination, verificationUUID),
    }), [handleVerificationRequired, verifyOtp]);
};

export { useOtpVerificationRequest, useOtpVerificationRequestRaw };
